<template>
  <modal :name="name" width="100%" height="100%" class="gallery-modal">
    <div class="gallery-modal__body">
      <close-btn @click="$modal.hide(name)" />

      <button
        v-if="hasSeveralImages"
        type="button"
        class="gallery-modal__arrow gallery-modal__arrow--prev"
        @click="prev"
      >
        ‹
      </button>

      <img
        v-if="activeImage"
        class="gallery-modal__image"
        :src="activeImage.source"
      />

      <button
        v-if="hasSeveralImages"
        type="button"
        class="gallery-modal__arrow gallery-modal__arrow--next"
        @click="next"
      >
        ›
      </button>

      <div v-if="hasSeveralImages" class="gallery-modal__counter">
        {{ currentIndex + 1 }} / {{ preparedImages.length }}
      </div>
    </div>
  </modal>
</template>

<script>
import CloseBtn from "@/components/shared/CloseBtn";

export default {
  components: {
    CloseBtn,
  },
  props: {
    name: {
      type: String,
      required: true,
      default: "gallery",
    },
    image: {
      type: String,
      default: null,
    },
    images: {
      type: Array,
      default() {
        return [];
      },
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      currentIndex: this.activeIndex || 0,
    };
  },
  computed: {
    preparedImages() {
      if (this.images && this.images.length) {
        return this.images
          .map((image) => {
            if (typeof image === "string") {
              return { source: image };
            }

            return image;
          })
          .filter((image) => image && image.source);
      }

      return this.image ? [{ source: this.image }] : [];
    },
    activeImage() {
      return this.preparedImages[this.currentIndex] || this.preparedImages[0];
    },
    hasSeveralImages() {
      return this.preparedImages.length > 1;
    },
  },
  watch: {
    activeIndex(value) {
      this.currentIndex = this.normalizeIndex(value);
    },
    images() {
      this.currentIndex = this.normalizeIndex(this.currentIndex);
    },
  },
  mounted() {
    document.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    normalizeIndex(index) {
      if (!this.preparedImages.length) {
        return 0;
      }

      if (index < 0) {
        return this.preparedImages.length - 1;
      }

      if (index >= this.preparedImages.length) {
        return 0;
      }

      return index;
    },
    setIndex(index) {
      this.currentIndex = this.normalizeIndex(index);
      this.$emit("change", this.currentIndex);
    },
    prev() {
      this.setIndex(this.currentIndex - 1);
    },
    next() {
      this.setIndex(this.currentIndex + 1);
    },
    onKeydown(event) {
      if (event.key === "ArrowLeft") {
        this.prev();
      }

      if (event.key === "ArrowRight") {
        this.next();
      }

      if (event.key === "Escape") {
        this.$modal.hide(this.name);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.gallery-modal {
  &__body {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    position: relative;
  }

  &__image {
    max-height: 100%;
    max-width: 100%;
  }

  &__arrow {
    align-items: center;
    background: rgba(0, 0, 0, 0.45);
    border: 0;
    border-radius: 50%;
    color: #fff;
    cursor: pointer;
    display: flex;
    font-size: 52px;
    height: 64px;
    justify-content: center;
    line-height: 1;
    padding: 0 0 6px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 64px;
    z-index: 2;

    &--prev {
      left: 24px;
    }

    &--next {
      right: 24px;
    }
  }

  &__counter {
    background: rgba(0, 0, 0, 0.45);
    border-radius: 20px;
    bottom: 24px;
    color: #fff;
    font-size: 14px;
    left: 50%;
    padding: 6px 14px;
    position: absolute;
    transform: translateX(-50%);
  }
}
</style>
